// @ts-nocheck
import {
  FETCH_CONTRACTOR_RATING_SUCCESS,
  FETCH_CONTRACTOR_RATINGS_BATCH_REQUEST,
  FETCH_CONTRACTOR_RATINGS_BATCH_SUCCESS,
  FETCH_CONTRACTOR_RATINGS_BATCH_FAILURE,
  UPSERT_CONTRACTOR_RATING_REQUEST,
  UPSERT_CONTRACTOR_RATING_SUCCESS,
  UPSERT_CONTRACTOR_RATING_FAILURE,
  ADD_CONTRACTOR_RATING_NOTE_REQUEST,
  ADD_CONTRACTOR_RATING_NOTE_SUCCESS,
  ADD_CONTRACTOR_RATING_NOTE_FAILURE,
  REMOVE_CONTRACTOR_RATING_NOTE_REQUEST,
  REMOVE_CONTRACTOR_RATING_NOTE_SUCCESS,
  REMOVE_CONTRACTOR_RATING_NOTE_FAILURE,
} from "../constants/contractorRatings";

export const initialState = {
  // { [contractorId]: { score, updatedBy, updatedAt, notes: [...] } }
  byContractorId: {},
  loading: false,
  // { [contractorId]: true|false }
  upserting: {},
  // { [contractorId]: true|false } — a note being added or removed
  savingNote: {},
};

const contractorRatingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONTRACTOR_RATING_SUCCESS: {
      const { contractorId, data } = action.payload;
      return {
        ...state,
        byContractorId: {
          ...state.byContractorId,
          [String(contractorId)]: data,
        },
      };
    }

    case FETCH_CONTRACTOR_RATINGS_BATCH_REQUEST:
      return { ...state, loading: true };

    case FETCH_CONTRACTOR_RATINGS_BATCH_SUCCESS: {
      const items = action.payload ?? [];
      const merged = { ...state.byContractorId };
      for (const r of items) {
        if (r?.contractorId) {
          merged[String(r.contractorId)] = r;
        }
      }
      return { ...state, loading: false, byContractorId: merged };
    }

    case FETCH_CONTRACTOR_RATINGS_BATCH_FAILURE:
      return { ...state, loading: false };

    case UPSERT_CONTRACTOR_RATING_REQUEST:
      return {
        ...state,
        upserting: {
          ...state.upserting,
          [action.payload.contractorId]: true,
        },
      };

    case UPSERT_CONTRACTOR_RATING_SUCCESS: {
      const { contractorId, data } = action.payload;
      return {
        ...state,
        upserting: { ...state.upserting, [contractorId]: false },
        byContractorId: {
          ...state.byContractorId,
          [String(contractorId)]: data,
        },
      };
    }

    case UPSERT_CONTRACTOR_RATING_FAILURE: {
      const id = action.payload?.contractorId;
      return {
        ...state,
        upserting: { ...state.upserting, [id]: false },
      };
    }

    // Add / remove note. Both endpoints return the whole rating document, so
    // the entry is replaced wholesale — the server's order is the display order.
    case ADD_CONTRACTOR_RATING_NOTE_REQUEST:
    case REMOVE_CONTRACTOR_RATING_NOTE_REQUEST:
      return {
        ...state,
        savingNote: {
          ...state.savingNote,
          [action.payload.contractorId]: true,
        },
      };

    case ADD_CONTRACTOR_RATING_NOTE_SUCCESS:
    case REMOVE_CONTRACTOR_RATING_NOTE_SUCCESS: {
      const { contractorId, data } = action.payload;
      return {
        ...state,
        savingNote: { ...state.savingNote, [contractorId]: false },
        byContractorId: {
          ...state.byContractorId,
          [String(contractorId)]: data,
        },
      };
    }

    case ADD_CONTRACTOR_RATING_NOTE_FAILURE:
    case REMOVE_CONTRACTOR_RATING_NOTE_FAILURE: {
      const id = action.payload?.contractorId;
      return {
        ...state,
        savingNote: { ...state.savingNote, [id]: false },
      };
    }

    default:
      return state;
  }
};

export default contractorRatingsReducer;
